import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import { Beneficiaries, BeneficiariesError } from './Beneficiaries';
import { RemoveBeneficiary, RemoveBeneficiaryError, RemoveBeneficiaryInvalidId, RemoveBeneficiaryNotFound } from './RemoveBeneficiary';
import { AddBeneficiary, AddBeneficiaryError, InvalidFormatBrithdate, InvalidRelationship } from './AddBeneficiary';
import { AssignPercentages, AssignPercentagesError, BeneficiaryDoesNotBelongToInvestor, BeneficiaryNotFound, DuplicateBeneficiaryId, InvalidBeneficiaryId, InvalidPercentage, InvalidTotalPercentage, MissingBeneficiaries } from './AssignPercentages';
class BeneficiariesAPI extends HundredBricksAPI {
    async addBeneficiary(payload) {
        try {
            const { data } = await this.client.post('v2/profile/beneficiaries', payload);
            return new AddBeneficiary(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_FORMAT_BIRTHDATE':
                        throw new InvalidFormatBrithdate({ cause: error });
                    case 'INVALID_RELATIONSHIP':
                        throw new InvalidRelationship({ cause: error });
                    default:
                        throw new AddBeneficiaryError({ cause: error });
                }
            }
            throw new AddBeneficiaryError(`Unexpected error when add beneficiary: '${error}'`);
        }
    }
    async beneficiaries() {
        try {
            const { data } = await this.client.get('v2/profile/beneficiaries');
            return data.map(item => new Beneficiaries(item));
        }
        catch (error) {
            if (error instanceof APIError) {
                throw new BeneficiariesError({ cause: error });
            }
            throw new BeneficiariesError(`Unexpected error when get beneficiaries: '${error}'`);
        }
    }
    async assignPercentages(payload) {
        try {
            const { data } = await this.client.put('v2/profile/beneficiaries/percentages', payload);
            return data.map(item => new AssignPercentages(item));
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_BENEFICIARY_ID':
                        throw new InvalidBeneficiaryId({ cause: error });
                    case 'DUPLICATE_BENEFICIARY_ID':
                        throw new DuplicateBeneficiaryId({ cause: error });
                    case 'INVALID_PERCENTAGE':
                        throw new InvalidPercentage({ cause: error });
                    case 'INVALID_TOTAL_PERCENTAGE':
                        throw new InvalidTotalPercentage({ cause: error });
                    case 'MISSING_BENEFICIARIES':
                        throw new MissingBeneficiaries({ cause: error });
                    case 'BENEFICIARY_NOT_FOUND':
                        throw new BeneficiaryNotFound({ cause: error });
                    case 'BENEFICIARY_DOES_NOT_BELONG_TO_INVESTOR':
                        throw new BeneficiaryDoesNotBelongToInvestor({ cause: error });
                    default:
                        throw new AssignPercentagesError({ cause: error });
                }
            }
            throw new AssignPercentagesError(`Unexpected error when assign percentages: '${error}'`);
        }
    }
    async removeBeneficiary(beneficiaryId) {
        try {
            const { data } = await this.client.delete(`v1/traders/me/beneficiaries/${beneficiaryId}`);
            return new RemoveBeneficiary(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_ID':
                        throw new RemoveBeneficiaryInvalidId({ cause: error });
                    case 'BENEFICIARY_NOT_FOUND':
                        throw new RemoveBeneficiaryNotFound({ cause: error });
                    default:
                        throw new RemoveBeneficiaryError({ cause: error });
                }
            }
            throw new RemoveBeneficiaryError(`Unexpected error when remove beneficiary: '${error}'`);
        }
    }
}
export default BeneficiariesAPI;
